import { button, notification, panel, signer } from "theme/colors";

const INK = "33, 21, 71";
// Brand red (#DD3824, = inkfree.main), not the retired design orange #E1500F:
// white "Next"/"Done" text on that orange was 3.92:1 (WCAG 1.4.3), and the
// app no longer shows that orange anywhere (CLAUDE.md §11.5).
const FLAME = "221, 56, 36";
const WHITE = "255, 255, 255";

const ink = (alpha: number): string => `rgba(${INK}, ${alpha})`;
const flame = (alpha: number): string => `rgba(${FLAME}, ${alpha})`;
const white = (alpha: number): string => `rgba(${WHITE}, ${alpha})`;

const INK_SOLID = `rgb(${INK})`;
const FLAME_SOLID = `rgb(${FLAME})`;
const WHITE_SOLID = `rgb(${WHITE})`;

export const tourColors = {
  primary: FLAME_SOLID,
  primaryHover: signer.orange.dark,
  onPrimary: WHITE_SOLID,

  textPrimary: INK_SOLID,
  textSecondary: signer.text.secondary,
  textMuted: signer.text.faint,
  closeIcon: "#8A85A0",

  surface: white(0.72),
  surfaceMobile: white(0.78),
  surfaceBorder: white(0.5),

  ghostBg: white(0.6),
  ghostBorder: button.secondaryBorderWarm,
  hoverBg: ink(0.06),

  dotActive: FLAME_SOLID,
  dotInactive: ink(0.12),

  overlay: ink(0.62),
  spotlightBorder: flame(0.5),

  modal: {
    surface: white(0.78),
    welcomeTile: `linear-gradient(135deg, ${signer.purple.main}, #EF403A)`,
    welcomeIcon: WHITE_SOLID,
    completeTile: notification.success.bg,
    completeIcon: notification.success.icon,
    footnote: "#B7B2C4",
  },

  shadow: {
    card: `0 16px 48px ${ink(0.18)}`,
    cardHairline: `0 0 0 1px ${ink(0.04)}`,
    cardMobile: `0 12px 40px ${ink(0.16)}`,
    modal: `0 20px 56px ${ink(0.2)}`,
  },

  launcher: {
    tileBg: signer.purple.tint,
    tileFg: signer.purple.main,
    title: panel.title,
    description: panel.metaText,
    hoverBg: panel.hover,
  },
} as const;

export default tourColors;
